import Vue from 'vue'
import config from '@/config/bl-config'

const locale = Vue.$cookies.isKey('locale') ? Vue.$cookies.get('locale') : Vue.$cookies.set('locale', { lang: 'he', dir: 'rtl' }, -1).get('locale')

export default {
  ...config,
  locale
}
